export class InterventionType {
  static UNDEFINED = -1;
  static CONTROL_ESFINTER = 0;
}
